import { Arg, FLEX_ARGS, Metadata, pick } from '../../../utils/spds/metadata';
import FlexRow from '../layout/flex/row.gjs';
import Super from '../core/base.gjs';
import Tag from './tag.gjs';

const METADATA = Metadata.define({
  description: `
    Tag group component that renders a collection of tags in a flex layout.
    Accepts an array of tag data objects or yields for manual tag composition.
  `,
  extends: [pick(FLEX_ARGS, ['flexWrap', 'gap'])],
  meta: {
    tagData: Arg.array({
      description: 'Array of tag data objects with label, type, icon, disabled, small, and onClose',
    }),
  },
  name: 'Tag Group',
  resources: {
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/v/0/p/41d5b1-tag',
  },
});

export default class SpdsIndicatorTagGroup extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-indicator-tag-group';

  get gap() {
    return this.argOrDefault('gap');
  }

  get flexWrap() {
    return this.argOrDefault('flexWrap');
  }

  <template>
    <FlexRow
      @flexWrap={{this.flexWrap}}
      @gap={{this.gap}}
      class={{this.classes}}
      data-test-spds-indicator-tag-group
      id={{this.id}}
      {{this.validateArguments}}
      ...attributes
    >
      {{#each @tagData as |tag index|}}
        <Tag
          @disabled={{tag.disabled}}
          @icon={{tag.icon}}
          @label={{tag.label}}
          @onClose={{tag.onClose}}
          @small={{tag.small}}
          @type={{tag.type}}
          data-test-spds-indicator-tag="{{this.id}}-{{tag.type}}-{{index}}"
        />
      {{else}}
        {{yield}}
      {{/each}}
    </FlexRow>
  </template>
}

export const TAG_GROUP_METADATA = SpdsIndicatorTagGroup.metadata;
